import React from "react";

import { lazyChunk, useChunk } from "./lazyChunk";

/* A formula, drawn by KaTeX once its chunk arrives with the first formula on a page. Until
   then, and for TeX KaTeX can't read, it is its source as written, `$`s and all. A displayed one
   is a centred line that scrolls sideways when it is wider than the answer.

   The drawing is KaTeX's HTML: it escapes the TeX it was given and, with `trust` off, adds no
   link or attribute that acts. */

const katex = lazyChunk(() => import("./katex"));

export default function MathFormula({ tex, display, source }: { tex: string; display: boolean; source: string }) {
  const html = useChunk(katex)?.renderMath(tex, display) ?? null;
  // a span either way: a displayed formula can sit inside a paragraph
  if (html === null) return <span className={display ? "block my-1" : undefined}>{source}</span>;
  return <span className={display ? "block overflow-x-auto overflow-y-hidden" : undefined} dangerouslySetInnerHTML={{ __html: html }} />;
}
